import { createLogger } from "../../helper/logger";
import { getAPI, postAPI } from "../services/api-services";
import { getPaginatedMockData } from "./mockedData/outputReviewMockData";

const logger = createLogger("OutputReviewAPI");
const baseURL = process.env.REACT_APP_API;
const isFakeAuth =
	process.env.REACT_APP_AUTH_FAKE_IT === "YES" ||
	process.env.REACT_APP_AUTH_FAKE_IT === "TRUE";

export const getOutputReview = async (
	caseID,
	token = "",
	page = 1,
	page_size = 10,
) => {
	// Return mock data when auth is faked
	if (isFakeAuth) {
		logger.debug("Using mock data for getOutputReview", {
			caseID,
			page,
			page_size,
		});
		await new Promise((resolve) => setTimeout(resolve, 500)); // Simulate server processing time

		// Get paginated data from our mock data generator
		const mockResponse = getPaginatedMockData(page, page_size);
		logger.debug("Returning paginated mock data", {
			itemCount: mockResponse.data.length,
			page,
			pageSize: page_size,
			totalItems: mockResponse.pagination.totalItems,
			totalPages: mockResponse.pagination.totalPages,
		});

		// Structure the response to match the API format with data and pagination keys
		return {
			data: mockResponse,
			loading: false,
			error: null,
		};
	}

	// Real API call when not in mock mode
	const url = `${baseURL}/api/getOutputAnalysisTable?case_id=${caseID}&page=${page}&page_size=${page_size}`;
	const { data, loading, error } = await getAPI(url, token);
	return { data, error, loading };
};

export const postOutputReview = async (caseID, body, action, token = "") => {
	// Return mock response when auth is faked
	if (isFakeAuth) {
		logger.debug("Using mock for postOutputReview", {
			caseID,
			action,
			bodyLength: body.length,
		});

		// Simulate server processing time
		await new Promise((resolve) => setTimeout(resolve, 500));

		let responseMessage = "";
		if (action === "save") {
			responseMessage = "Results saved successfully.";
		} else if (action === "confirm") {
			responseMessage = "Results saved and confirmed successfully.";
		}

		return {
			data: responseMessage,
			loading: false,
			error: null,
		};
	}

	// Real API call when not in mock mode
	const url = `${baseURL}/api/saveAndConfirmResults/?case_id=${caseID}&action=${action}`;
	const { data, loading, error } = await postAPI(url, body, token);
	return { data, error, loading };
};
